import { gql } from '@apollo/client';

export default gql`
  mutation editInspectionSubject(
    $id: ID!
    $name: String!
    $brand: String
    $model: String
    $serialNumber: String
    $placeId: ID
    $notes: String
  ) {
    editInspectionSubject(
      input: {
        id: $id
        name: $name
        brand: $brand
        model: $model
        serialNumber: $serialNumber
        placeId: $placeId
        notes: $notes
      }
    ) {
      inspectionSubject {
        id
        name
      }
    }
  }
`;
